import { render, staticRenderFns } from "./OrderTable.vue?vue&type=template&id=fd6774c4&scoped=true&"
import script from "./OrderTable.vue?vue&type=script&lang=js&"
export * from "./OrderTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderTable.vue?vue&type=style&index=0&id=fd6774c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6774c4",
  null
  
)

export default component.exports